<template>
  <v-main>
    <v-container class="pa-0 ma-0" fluid>
      <v-layout justify-center>
        <v-flex xs12>
          <v-toolbar color="primary" dark flat>
            <v-icon color="white" class="mr-2">mdi-puzzle-edit</v-icon>
            <v-spacer></v-spacer>
            <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp"
              >{{ $t("userNewPhotoGiftOrderFinalizeTitle") }} ({{
                $store.state.storePhotoGiftOrderDesign.itemCategory
              }}
              /
              {{
                $store.state.storePhotoGiftOrderDesign.itemSubCategory
              }})</v-toolbar-title
            >
            <v-toolbar-title
              class="subtitle-1"
              style="line-height: 18px"
              v-else
            >
              {{ $t("userNewPhotoGiftOrderFinalizeTitle") }}<br />
              <span style="font-size: 12px"
                >{{ $store.state.storePhotoGiftOrderDesign.itemCategory }}
                /
                {{
                  $store.state.storePhotoGiftOrderDesign.itemSubCategory
                }}</span
              ></v-toolbar-title
            >
            <v-spacer></v-spacer>
            <!-- SHOW GO BACK BUTTON CONFIRM DIALOG -->
            <dialog-show-go-back
              :active="showGoBack"
              @clickYes="$router.push('/')"
              @clickNo="showGoBack = false"
            ></dialog-show-go-back>
          </v-toolbar>

          <!-- PODROBNOSTI NAROČILA -->
          <!-- ne prikažemo, če gre za darilni bon -->
          <v-flex
            d-flex
            xs12
            v-if="$store.state.storePhotoGiftOrderDesign.superType !== 4"
          >
            <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
            <v-card
              outlined
              class="ma-1"
              :class="$vuetify.breakpoint.smAndUp ? 'mt-6' : ''"
              :style="
                $vuetify.breakpoint.smAndUp
                  ? 'max-width: 600px; width:600px'
                  : 'width:100%'
              "
            >
              <v-card-title
                class="
                  secondary
                  white--text
                  justify-center
                  subtitle-2
                  ma-0
                  py-1
                "
              >
                {{ $t("settingsPhotoGiftDetailsTitle") }}
              </v-card-title>
              <v-card-text class="px-2 pb-0 pt-3">
                <div
                  v-if="
                    $store.state.storePhotoGiftOrderDesign.simpleType &&
                    !$store.state.storePhotoGiftOrderDesign.allowTemplateClones
                  "
                >
                  <v-select
                    v-if="
                      $store.state.storePhotoGiftOrderDesign
                        .itemTypeSelectOptions.length > 1
                    "
                    class="pa-0 ma-0"
                    v-model="$store.state.storePhotoGiftOrderDesign.itemType"
                    :items="
                      $store.state.storePhotoGiftOrderDesign
                        .itemTypeSelectOptions
                    "
                    :label="$t('settingsPhotoGiftType2Title')"
                    style="height: 50px"
                    dense
                    outlined
                  ></v-select>
                </div>
                <div
                  v-else-if="
                    !$store.state.storePhotoGiftOrderDesign.allowTemplateClones
                  "
                  class="pa-0 ma-0"
                >
                  <v-card
                    outlined
                    class="d-flex pa-2 mb-3"
                    v-if="
                      $store.state.storePhotoGiftOrderDesign.selectedTypeArray
                        .price > 0
                    "
                    @click="serveItemTypeSelection"
                  >
                    <v-img
                      style="max-width: 100px; max-height: 100px"
                      :src="
                        $store.state.storePhotoGiftOrderDesign.selectedTypeArray
                          .image
                      "
                    ></v-img>
                    <div class="mx-2">
                      <div class="subtitle-2 font-weight-bold">
                        {{
                          $store.state.storePhotoGiftOrderDesign
                            .selectedTypeArray.title
                        }}
                      </div>
                      <div
                        class="subtitle-2 mt-2 font-weight-regular"
                        v-if="
                          $store.state.storePhotoGiftOrderDesign
                            .selectedTypeArray.description.length > 0
                        "
                      >
                        {{
                          $store.state.storePhotoGiftOrderDesign
                            .selectedTypeArray.description
                        }}
                      </div>
                      <div class="overline">
                        <v-icon>mdi-cash-multiple</v-icon>
                        {{
                          price(
                            $store.state.storePhotoGiftOrderDesign
                              .selectedTypeArray.price
                          )
                        }}
                      </div>
                      <div
                        v-if="
                          $store.state.storePhotoGiftOrderDesign
                            .selectedTypeArray.discount
                        "
                        class="overline my-2"
                      >
                        <span
                          class="pa-2"
                          style="
                            text-align: center;
                            background-color: #cc0000;
                            border-radius: 8px;
                            color: white;
                          "
                        >
                          {{ $t("userNewOrderSummary5aTitle") }}
                          {{
                            $store.state.storePhotoGiftOrderDesign
                              .selectedTypeArray.promoCode
                          }}
                          <span
                            v-if="
                              $store.state.storePhotoGiftOrderDesign
                                .selectedTypeArray.discountType == 'Pct'
                            "
                            >-{{
                              $store.state.storePhotoGiftOrderDesign
                                .selectedTypeArray.discount
                            }}%</span
                          >
                          <span
                            v-else-if="
                              $store.state.storePhotoGiftOrderDesign
                                .selectedTypeArray.discountType == 'Amt'
                            "
                            >-{{
                              price(
                                $store.state.storePhotoGiftOrderDesign
                                  .selectedTypeArray.discount
                              )
                            }}</span
                          ></span
                        >
                      </div>
                    </div>
                  </v-card>
                  <div v-else class="d-flex mt-1 mb-4">
                    <v-spacer></v-spacer>
                    <v-btn
                      medium
                      color="accent"
                      class="elevation-0"
                      @click="serveItemTypeSelection"
                    >
                      <v-icon medium color="white" class="mr-1"
                        >mdi-view-list</v-icon
                      >
                      {{ $t("userNewPhotoGiftOrderSelectTypeTitle") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                  </div>
                </div>
                <!-- za navaden izdelek ponudimo izbiro števila kopij -->
                <v-select
                  v-if="
                    !$store.state.storePhotoGiftOrderDesign.allowTemplateClones
                  "
                  class="pa-0 ma-0"
                  v-model="$store.state.storePhotoGiftOrderDesign.itemCopies"
                  :items="
                    $store.state.storePhotoGiftOrderDesign
                      .itemCopiesSelectOptions
                  "
                  style="height: 50px"
                  :label="$t('settingsPhotoGiftCopiesTitle')"
                  @change="setNewPrice"
                  dense
                  outlined
                ></v-select>
                <!-- izpis cene za navaden izdelek -->
                <div
                  class="pa-0 ma-0 overline d-flex"
                  v-if="
                    !$store.state.storePhotoGiftOrderDesign
                      .allowTemplateClones &&
                    $store.state.storePhotoGiftOrderDesign.itemFullPrice > 0 &&
                    $store.state.storePhotoGiftOrderDesign.simpleType
                  "
                >
                  <v-spacer></v-spacer>
                  <div>
                    {{ $t("settingsPhotoGiftPriceTitle") }}:
                    {{
                      price(
                        $store.state.storePhotoGiftOrderDesign.itemFullPrice
                      )
                    }}
                  </div>
                  <v-spacer></v-spacer>
                </div>
                <!-- izpis cene za allowTemplateClones -->
                <div
                  class="pa-0 ma-0 overline d-flex"
                  v-else-if="
                    $store.state.storePhotoGiftOrderDesign.allowTemplateClones
                  "
                >
                  <v-spacer></v-spacer>
                  <div>
                    {{ $t("settingsPhotoGiftPriceTitle") }}:
                    <span
                      v-if="
                        $store.state.storePhotoGiftOrderDesign
                          .maxTemplateClones <= 0
                      "
                      >{{
                        price(
                          $store.state.storePhotoGiftOrderDesign.itemFullPrice
                        )
                      }}</span
                    >
                    <span v-else>{{
                      price($store.state.storePhotoGiftOrderDesign.itemPrice)
                    }}</span>
                    / {{ $store.state.storePhotoGiftOrderDesign.itemCopies }}
                    {{ $t("lmPcs") }}
                  </div>
                  <v-spacer></v-spacer>
                </div>
                <div class="d-flex mb-5">
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" class="mt-2" @click="checkIfOrderOK">
                    <v-icon class="mr-2">mdi-cart</v-icon>
                    {{ $t("commonNewOrderOrderAddToCartTitle") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </div>
              </v-card-text>
            </v-card>
            <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
          </v-flex>
        </v-flex>

        <!-- PLEASE WAIT DIALOG -->
        <v-dialog
          v-model="dialogWait"
          persistent
          max-width="400"
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-card-title class="headline">{{
              $t("userNewOrderPleaseWaitTitle")
            }}</v-card-title>
            <v-card-text>
              {{ dialogWaitMsg }}
            </v-card-text>
            <v-card-text class="d-flex">
              <v-spacer></v-spacer>
              <v-progress-linear
                color="primary"
                height="10"
                indeterminate
              ></v-progress-linear>
              <v-spacer></v-spacer>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- ITEM TYPE SELECTION DIALOG -->
        <dialog-item-type-selection
          v-model="showItemTypeSelection"
          :templateVar="
            $store.state.storePhotoGiftOrderDesign.showItemTypeSelectionArray
          "
          :desc="desc"
          @update:desc="desc = $event"
          @selectedId="changeItemType($event)"
        ></dialog-item-type-selection>

        <!-- DIALOG UPLOAD -->
        <dialog-upload
          :active="showUpload"
          @clickNewOrder="$router.push({ name: 'home' })"
        ></dialog-upload>

        <v-snackbar
          absolute
          v-model="$store.state.storeSnackbar.snackbar.active"
          :color="$store.state.storeSnackbar.snackbar.color"
          :timeout="$store.state.storeSnackbar.snackbar.timeout"
          >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
        >
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import DialogItemTypeSelection from "@/components/DialogItemTypeSelection";
import DialogShowGoBack from "@/components/DialogShowGoBack";
import DialogUpload from "@/components/DialogUpload";
import * as JSZip from "jszip";
import moment from "moment";
import firebase from "firebase/app"; // za servertimestamp
import * as c from "@/constants";
import { storage } from "@/firebase";
import { formatBytes, makeId } from "@/mixins/utils";

export default {
  name: "userNewPhotoGiftOrderFinalize",
  components: {
    DialogItemTypeSelection,
    DialogUpload,
    DialogShowGoBack,
  },
  data() {
    return {
      showGoBack: false,
      showUpload: false,
      dialogMsg: false,
      dialogWait: false,
      dialogWaitMsg: "",
      showItemTypeSelection: false,
      desc: false,
      itemTypeId: "",
    };
  },
  methods: {
    setNewPrice() {
      if (this.$store.state.storePhotoGiftOrderDesign.simpleType) {
        this.$store.state.storePhotoGiftOrderDesign.itemFullPrice =
          Number(this.$store.state.storePhotoGiftOrderDesign.itemPrice) *
          Number(this.$store.state.storePhotoGiftOrderDesign.itemCopies);
      } else {
        this.$store.state.storePhotoGiftOrderDesign.itemPrice =
          this.$store.state.storePhotoGiftOrderDesign.selectedTypeArray.price;
        this.$store.state.storePhotoGiftOrderDesign.itemFullPrice =
          Number(this.$store.state.storePhotoGiftOrderDesign.itemPrice) *
          Number(this.$store.state.storePhotoGiftOrderDesign.itemCopies);
      }
    },
    serveItemTypeSelection() {
      this.showItemTypeSelection = true;
    },
    changeItemType(id) {
      this.showItemTypeSelection = false;
      this.$store.state.storePhotoGiftOrderDesign.selectedTypeArray =
        this.$store.state.storePhotoGiftOrderDesign.showItemTypeSelectionArray.filter(
          (x) => x.id == id
        )[0];
      this.itemTypeId =
        this.$store.state.storePhotoGiftOrderDesign.selectedTypeArray.id;
      this.$store.state.storePhotoGiftOrderDesign.itemType =
        this.$store.state.storePhotoGiftOrderDesign.selectedTypeArray.title;
      this.$store.state.storePhotoGiftOrderDesign.itemPrice =
        this.$store.state.storePhotoGiftOrderDesign.selectedTypeArray.price;
      this.$store.state.storePhotoGiftOrderDesign.itemFullPrice =
        Number(this.$store.state.storePhotoGiftOrderDesign.itemPrice) *
        Number(this.$store.state.storePhotoGiftOrderDesign.itemCopies);
    },
    async checkIfOrderOK() {
      if (!this.$store.state.storePhotoGiftOrderDesign.allowTemplateClones) {
        if (
          Number(this.$store.state.storePhotoGiftOrderDesign.itemCopies) > 0 &&
          ((((this.$store.state.storePhotoGiftOrderDesign.itemTypeSelectOptions
            .length > 1 &&
            this.$store.state.storePhotoGiftOrderDesign.itemType.length > 0) ||
            this.$store.state.storePhotoGiftOrderDesign.itemTypeSelectOptions
              .length <= 1) &&
            this.$store.state.storePhotoGiftOrderDesign.simpleType) ||
            (!this.$store.state.storePhotoGiftOrderDesign.simpleType &&
              this.$store.state.storePhotoGiftOrderDesign.itemType.length > 0))
        ) {
          // pri advanced različicah preverimo ali morda število naročenih izdelkov
          // ne pride že pod zalogo?
          if (
            !this.$store.state.storePhotoGiftOrderDesign.simpleType &&
            this.$store.state.storePhotoGiftOrderDesign.selectedTypeArray
              .inventory -
              this.$store.state.storePhotoGiftOrderDesign.itemCopies <
              0 &&
            this.$store.state.storePhotoGiftOrderDesign.selectedTypeArray
              .inventory != -1
          ) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message:
                this.$t("settingsPhotoGiftFormInventoryErrorTitle") +
                " " +
                this.$store.state.storePhotoGiftOrderDesign.selectedTypeArray
                  .inventory,
            });
          } else {
            // IZPOLNITEV PREDLOGE
            //this.uploadedFiles = [];
            //this.uploadError = null;
            this.$store.state.storeModPhotoOrderUploadService.generatingZipProgress =
              {};
            this.$store.state.storeModPhotoOrderUploadService.uploadProgress =
              {};
            this.showUpload = true;
            //await new Promise((r) => setTimeout(r, 200)); // počakamo trenutek, da se pokaže waitDialog
            this.uploadFiles();
          }
        } else {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: this.$t("userNewPhotoGiftOrderFinalizeFormError"),
          });
        }
      } else {
        // IZPOLNITEV PREDLOGE
        //this.uploadedFiles = [];
        //this.uploadError = null;

        if (this.$store.state.storePhotoGiftOrderDesign.maxTemplateClones > 0)
          this.$store.state.storePhotoGiftOrderDesign.itemCopies = 1;

        console.log("AAA");
        this.$store.state.storeModPhotoOrderUploadService.generatingZipProgress =
          {};
        this.$store.state.storeModPhotoOrderUploadService.uploadProgress = {};
        this.showUpload = true;
        this.uploadFilesClones();
      }
    },
    async uploadFilesClones() {
      try {
        console.log("UPLOAD FILES CLONES...");
        var zip = new JSZip();
        //zip.file("order_details.txt", this.$store.state.storeAuth.user.uid); // Add an top-level, arbitrary text file with contents

        let st = 0;
        let numOfFiles =
          this.$store.state.storePhotoGiftOrderDesign.multipleCopies.length; // za preverjanje ali so se generirale vse datoteke
        let builtFileName = "";

        Array.from(
          this.$store.state.storePhotoGiftOrderDesign.multipleCopies
        ).forEach(async (fileToLoad) => {
          // Add a file to the directory, in this case an image with data URI as contents
          console.log(fileToLoad);
          if (this.$store.state.storePhotoGiftOrderDesign.allowCustomSize) {
            builtFileName =
              st +
              "-" +
              fileToLoad.size +
              "-" +
              fileToLoad.copies +
              this.$t("lmPcs") +
              "-" +
              this.$store.state.storePhotoGiftOrderDesign.itemSubCategory.replace(
                /\W/g,
                ""
              ) +
              "." +
              fileToLoad.cUrlType;
          } else
            builtFileName =
              st +
              "-" +
              fileToLoad.copies +
              this.$t("lmPcs") +
              "-" +
              this.$store.state.storePhotoGiftOrderDesign.itemCategory.replace(
                /\W/g,
                ""
              ) +
              "-" +
              this.$store.state.storePhotoGiftOrderDesign.itemSubCategory.replace(
                /\W/g,
                ""
              ) +
              "." +
              fileToLoad.cUrlType;

          if (fileToLoad.cUrlType == "png") {
            zip.file(
              builtFileName,
              fileToLoad.cUrl2.replace(/^data:image\/png;base64,/, ""),
              {
                base64: true,
              }
            );
          } else
            zip.file(
              builtFileName,
              fileToLoad.cUrl.replace(/^data:image\/jpeg;base64,/, ""),
              {
                base64: true,
              }
            );
          st++;
        });

        await new Promise((r) => setTimeout(r, 0)); // sleep, tudi če je 0, poskrbi da gre vse zaporedno

        setTimeout(() => {
          if (numOfFiles == st) {
            // Generate the zip file asynchronously
            let vm = this;
            const fileNameType = this.$t("fileNamePackageItems");
            // preberemo ime uporabnika, če ga ni, potem predpono emaila, sicer pa random string
            let fileFullName =
              this.$store.state.storeAuth.userProfile.fullName !== undefined &&
              this.$store.state.storeAuth.userProfile.fullName.length > 0
                ? this.$store.state.storeAuth.userProfile.fullName.replace(
                    /\W/g,
                    ""
                  )
                : "";
            fileFullName =
              fileFullName.length > 0
                ? fileFullName
                : this.$store.state.storeAuth.userProfile.email !== undefined &&
                  this.$store.state.storeAuth.userProfile.email.length > 0
                ? this.$store.state.storeAuth.userProfile.email.split("@")[0]
                : "";
            fileFullName =
              fileFullName.length > 0 ? fileFullName : makeId(5, 0);

            zip
              .generateAsync(
                { type: "blob" },
                function updateCallback(metadata) {
                  vm.$store.dispatch("generatingZipProgress", {
                    progress: metadata.percent.toFixed(0),
                    currentFile: metadata.currentFile,
                  });
                }
              )
              .then(function (content) {
                const uploadFileName = `${fileFullName}-${fileNameType}-${moment().format(
                  "YYYYMMDD"
                )}-${moment().format("HHmmss")}-${
                  vm.$store.state.storeClient.client.basicSettings.name
                }.zip`;

                const uploadPath =
                  c.G_STORAGE_DEFAULT_DIR + "/" + uploadFileName;

                const storageRef = storage.ref().child(uploadPath);
                let uploadTask = storageRef.put(content);
                let zipSize,
                  rawZipSize = 0;

                uploadTask.on(
                  "state_changed",
                  function progress(snapshot) {
                    const progress =
                      (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    vm.$store.dispatch("uploadProgress", {
                      progress: Math.trunc(progress),
                      bytesTransferred: formatBytes(snapshot.bytesTransferred),
                      totalBytes: formatBytes(snapshot.totalBytes),
                    });
                    zipSize = formatBytes(snapshot.totalBytes);
                    rawZipSize = snapshot.totalBytes;
                    //console.log(zipSize);
                  },
                  function error(err) {
                    alert(err);
                  },
                  function complete() {
                    // generate download URL
                    storage
                      .ref()
                      .child(uploadPath)
                      .getDownloadURL()
                      .then(function (url) {
                        vm.$store.dispatch("addToCart", {
                          uid: vm.$store.state.storeAuth.user.uid,
                          module: c.G_MODULE_PHOTO_GIFT,
                          timestamp:
                            firebase.firestore.FieldValue.serverTimestamp(),
                          url: url,
                          zipSize: zipSize,
                          itemSuperCategoryId:
                            vm.$store.state.storePhotoGiftOrderDesign
                              .itemSuperCategoryId,
                          itemCategoryId:
                            vm.$store.state.storePhotoGiftOrderDesign
                              .itemMainCategoryId,
                          itemSimpleType:
                            vm.$store.state.storePhotoGiftOrderDesign
                              .simpleType,
                          itemId:
                            vm.$store.state.storePhotoGiftOrderDesign.itemId,
                          itemTypeId: vm.itemTypeId,
                          itemType:
                            vm.$store.state.storePhotoGiftOrderDesign.itemType,
                          itemCopies: vm.$store.state.storePhotoGiftOrderDesign
                            .allowCustomSize
                            ? 1
                            : Number(
                                vm.$store.state.storePhotoGiftOrderDesign
                                  .itemCopies
                              ),
                          itemPrice: vm.$store.state.storePhotoGiftOrderDesign
                            .allowCustomSize
                            ? Number(
                                vm.$store.state.storePhotoGiftOrderDesign
                                  .itemFullPrice
                              )
                            : Number(
                                vm.$store.state.storePhotoGiftOrderDesign
                                  .itemPrice
                              ),
                          itemName:
                            vm.$store.state.storePhotoGiftOrderDesign
                              .itemCategory +
                            " | " +
                            vm.$store.state.storePhotoGiftOrderDesign.itemName,
                          sendExtraEmailOnOrder:
                            vm.$store.state.storePhotoGiftOrderDesign
                              .sendExtraEmailOnOrder,
                          rawZipSize: rawZipSize,
                          client:
                            vm.$store.state.storeClient.client.basicSettings
                              .name,
                          email: vm.$store.state.storeAuth.user.email,
                          cartId: uploadFileName,
                          status: 0,
                          done: false,
                          superType:
                            vm.$store.state.storePhotoGiftOrderDesign.superType,
                          debugInfo: {
                            appVersion:
                              vm.$store.getters.appVersion !== undefined
                                ? vm.$store.getters.appVersion
                                : "",
                            appOS:
                              vm.$store.state.os !== undefined
                                ? vm.$store.state.os
                                : "",
                            appBrowser:
                              vm.$store.state.browser !== undefined
                                ? vm.$store.state.browser
                                : "",
                            appMemory:
                              vm.$store.state.memory !== undefined
                                ? String(vm.$store.state.memory)
                                : "",
                          },
                        });
                      })
                      .catch(function (error) {
                        alert(error);
                      });
                  }
                );
              });
          } else {
            alert(this.$t("errorGeneratingGiftImages"));
            this.$router.push("/");
          }
        }, 0);
      } catch (error) {
        console.log(error);
        alert(this.$t("errorGeneratingGiftImages"));
        this.$router.push("/");
      }
    },
    async uploadFiles() {
      // zmanjšamo zalogo, če obstaja
      let result = false;
      if (
        this.$store.state.storePhotoGiftOrderDesign.selectedTypeArray
          .inventory > 0
      )
        result = await this.$store.dispatch("changeGiftInventory", {
          itemSimpleType:
            this.$store.state.storePhotoGiftOrderDesign.simpleType,
          itemId: this.$store.state.storePhotoGiftOrderDesign.itemId,
          itemTypeId: this.itemTypeId,
          num: -Number(this.$store.state.storePhotoGiftOrderDesign.itemCopies),
        });

      try {
        console.log("CREATING ZIP...");
        var zip = new JSZip();
        //zip.file("order_details.txt", this.$store.state.storeAuth.user.uid); // Add an top-level, arbitrary text file with contents

        let st = 0;
        let numOfFiles =
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates.length; // za preverjanje ali so se generirale vse datoteke
        let builtFileName = "";
        let isOnlyOne =
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates.length > 1
            ? false
            : true; // ali imamo samo en template?

        Array.from(
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates
        ).forEach(async (fileToLoad) => {
          let cNum = "";
          if (st < 10) {
            cNum = "00" + String(st);
          } else if (st < 100) {
            cNum = "0" + String(st);
          } else cNum = String(st);

          // če je Foto platno ali povečava in če je zraven original file, ga tudi naložimo zraven
          if (
            (this.$store.state.storePhotoGiftOrderDesign.superType == 5 ||
              this.$store.state.storePhotoGiftOrderDesign.superType == 6) &&
            fileToLoad.mainFile
          ) {
            zip.file(
              cNum + "-original-" + fileToLoad.mainFile.name,
              fileToLoad.mainFile
            );
          }
          // Add a file to the directory, in this case an image with data URI as contents
          //console.log(fileToLoad);
          console.log(this.$store.state.storePhotoGiftOrderDesign);
          builtFileName =
            cNum +
            "-" +
            this.$store.state.storePhotoGiftOrderDesign.itemCopies +
            this.$t("lmPcs") +
            "-" +
            (isOnlyOne ? "" : fileToLoad.title + "-") +
            this.$store.state.storePhotoGiftOrderDesign.itemCategory.replace(
              /\W/g,
              ""
            ) +
            "-" +
            this.$store.state.storePhotoGiftOrderDesign.itemSubCategory.replace(
              /\W/g,
              ""
            ) +
            (this.$store.state.storePhotoGiftOrderDesign.itemType.length > 0
              ? "-" +
                this.$store.state.storePhotoGiftOrderDesign.itemType.replace(
                  /\W/g,
                  ""
                )
              : "") +
            "." +
            fileToLoad.cUrlType;

          if (fileToLoad.cUrlType == "png") {
            zip.file(
              builtFileName,
              fileToLoad.cUrl2.replace(/^data:image\/png;base64,/, ""),
              {
                base64: true,
              }
            );
          } else
            zip.file(
              builtFileName,
              fileToLoad.cUrl.replace(/^data:image\/jpeg;base64,/, ""),
              {
                base64: true,
              }
            );
          st++;
        });

        await new Promise((r) => setTimeout(r, 0)); // sleep, tudi če je 0, poskrbi da gre vse zaporedno

        setTimeout(() => {
          if (numOfFiles == st) {
            // Generate the zip file asynchronously
            let vm = this;
            const fileNameType = this.$t("fileNamePackageItems");
            // preberemo ime uporabnika, če ga ni, potem predpono emaila, sicer pa random string
            let fileFullName =
              this.$store.state.storeAuth.userProfile.fullName !== undefined &&
              this.$store.state.storeAuth.userProfile.fullName.length > 0
                ? this.$store.state.storeAuth.userProfile.fullName.replace(
                    /\W/g,
                    ""
                  )
                : "";
            fileFullName =
              fileFullName.length > 0
                ? fileFullName
                : this.$store.state.storeAuth.userProfile.email !== undefined &&
                  this.$store.state.storeAuth.userProfile.email.length > 0
                ? this.$store.state.storeAuth.userProfile.email.split("@")[0]
                : "";
            fileFullName =
              fileFullName.length > 0 ? fileFullName : makeId(5, 0);

            zip
              .generateAsync(
                { type: "blob" },
                function updateCallback(metadata) {
                  vm.$store.dispatch("generatingZipProgress", {
                    progress: metadata.percent.toFixed(0),
                    currentFile: metadata.currentFile,
                  });
                }
              )
              .then(function (content) {
                const uploadFileName = `${fileFullName}-${fileNameType}-${moment().format(
                  "YYYYMMDD"
                )}-${moment().format("HHmmss")}-${
                  vm.$store.state.storeClient.client.basicSettings.name
                }.zip`;

                const uploadPath =
                  c.G_STORAGE_DEFAULT_DIR + "/" + uploadFileName;

                const storageRef = storage.ref().child(uploadPath);
                let uploadTask = storageRef.put(content);
                let zipSize,
                  rawZipSize = 0;

                uploadTask.on(
                  "state_changed",
                  function progress(snapshot) {
                    const progress =
                      (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    vm.$store.dispatch("uploadProgress", {
                      progress: Math.trunc(progress),
                      bytesTransferred: formatBytes(snapshot.bytesTransferred),
                      totalBytes: formatBytes(snapshot.totalBytes),
                    });
                    zipSize = formatBytes(snapshot.totalBytes);
                    rawZipSize = snapshot.totalBytes;
                    //console.log(zipSize);
                  },
                  function error(err) {
                    alert(err);
                  },
                  function complete() {
                    // generate download URL
                    storage
                      .ref()
                      .child(uploadPath)
                      .getDownloadURL()
                      .then(function (url) {
                        //console.log(url);
                        let saveCart = {
                          uid: vm.$store.state.storeAuth.user.uid,
                          module: c.G_MODULE_PHOTO_GIFT,
                          timestamp:
                            firebase.firestore.FieldValue.serverTimestamp(),
                          url: url,
                          zipSize: zipSize,
                          itemSuperCategoryId:
                            vm.$store.state.storePhotoGiftOrderDesign
                              .itemSuperCategoryId,
                          itemCategoryId:
                            vm.$store.state.storePhotoGiftOrderDesign
                              .itemMainCategoryId,
                          itemSimpleType:
                            vm.$store.state.storePhotoGiftOrderDesign
                              .simpleType,
                          itemId:
                            vm.$store.state.storePhotoGiftOrderDesign.itemId,
                          itemTypeId: vm.itemTypeId,
                          itemType:
                            vm.$store.state.storePhotoGiftOrderDesign.itemType,
                          itemCopies: Number(
                            vm.$store.state.storePhotoGiftOrderDesign.itemCopies
                          ),
                          itemPrice: Number(
                            vm.$store.state.storePhotoGiftOrderDesign.itemPrice
                          ),
                          itemName:
                            vm.$store.state.storePhotoGiftOrderDesign
                              .itemCategory +
                            " | " +
                            vm.$store.state.storePhotoGiftOrderDesign.itemName,
                          sendExtraEmailOnOrder:
                            vm.$store.state.storePhotoGiftOrderDesign
                              .sendExtraEmailOnOrder,
                          rawZipSize: rawZipSize,
                          client:
                            vm.$store.state.storeClient.client.basicSettings
                              .name,
                          email: vm.$store.state.storeAuth.user.email,
                          cartId: uploadFileName,
                          status: 0,
                          done: false,
                          superType:
                            vm.$store.state.storePhotoGiftOrderDesign.superType,
                          debugInfo: {
                            appVersion:
                              vm.$store.getters.appVersion !== undefined
                                ? vm.$store.getters.appVersion
                                : "",
                            appOS:
                              vm.$store.state.os !== undefined
                                ? vm.$store.state.os
                                : "",
                            appBrowser:
                              vm.$store.state.browser !== undefined
                                ? vm.$store.state.browser
                                : "",
                            appMemory:
                              vm.$store.state.memory !== undefined
                                ? String(vm.$store.state.memory)
                                : "",
                          },
                        };

                        // pri darilnih bonih dodamo še nekaj dodatnih podatkov
                        if (
                          vm.$store.state.storePhotoGiftOrderDesign.superType ==
                          4
                        ) {
                          saveCart = Object.assign({}, saveCart, {
                            itemGiftCardCode:
                              vm.$store.state.storePhotoGiftOrderDesign
                                .itemGiftCardCode,
                            itemGiftCardValidTo: new Date(
                              vm.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo
                            ),
                          });
                        }

                        vm.$store.dispatch("addToCart", saveCart);
                      })
                      .catch(function (error) {
                        alert(error);
                      });
                  }
                );
              });
          } else {
            alert(this.$t("errorGeneratingGiftImages"));
            this.$router.push("/");
          }
        }, 0);
      } catch (error) {
        if (result)
          this.$store.dispatch("changeGiftInventory", {
            itemSimpleType:
              this.$store.state.storePhotoGiftOrderDesign.simpleType,
            itemId: this.$store.state.storePhotoGiftOrderDesign.itemId,
            itemTypeId: this.itemTypeId,
            num: Number(this.$store.state.storePhotoGiftOrderDesign.itemCopies),
          });
        console.log(error);
        alert(this.$t("errorGeneratingGiftImages"));
        this.$router.push("/");
      }
    },
  },
  mounted() {
    // darilne bone zaključimo takoj, vedno 1 kom
    if (this.$store.state.storePhotoGiftOrderDesign.superType == 4) {
      this.$store.state.storePhotoGiftOrderDesign.itemCopies = 1;
      this.$store.state.storeModPhotoOrderUploadService.generatingZipProgress =
        {};
      this.$store.state.storeModPhotoOrderUploadService.uploadProgress = {};
      this.showUpload = true;
      this.uploadFiles();
    }
  },
};
</script>

<style scoped>
</style>